import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToSection } from "@/lib/scroll";

const serviceLinks = [
  "End of Tenancy Cleaning",
  "Office Cleaning",
  "Domestic & Residential",
  "Carpet & Upholstery",
  "Laundry & Ironing",
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-900 py-24 text-white lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-12">
      <div className="mb-20 flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
        <h2 className="max-w-2xl font-serif text-4xl font-medium leading-tight tracking-tight sm:text-5xl lg:text-6xl">
          Let's make it <span className="italic text-teal-300">sparkle.</span>
        </h2>
        <a
          data-testid="footer-call-button"
          href="tel:07776714973"
          className="group flex w-fit items-center gap-2 rounded-full bg-teal-500 px-8 py-4 text-sm font-bold text-slate-950 transition-transform duration-300 hover:scale-105 hover:bg-teal-400"
        >
          Call 07776 714 973
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>

      <div className="grid grid-cols-1 gap-12 border-t border-white/10 pt-14 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <Logo className="h-9 w-9" />
            <span className="leading-none">
              <span className="block font-serif text-xl font-semibold tracking-tight">Hyek</span>
              <span className="mt-0.5 block text-[9px] font-bold uppercase tracking-[0.2em] text-teal-300">
                Cleaning Services Ltd
              </span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Sparkling spaces, healthier living. Premium cleaning for homes and businesses across the region.
          </p>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Services</h3>
          <ul className="mt-5 flex flex-col gap-3">
            {serviceLinks.map((s) => (
              <li key={s}>
                <button
                  data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  onClick={() => scrollToSection("#services")}
                  className="text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300"
                >
                  {s}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Company</h3>
          <ul className="mt-5 flex flex-col gap-3">
            <li>
              <button data-testid="footer-about-link" onClick={() => scrollToSection("#about")} className="text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300">
                About Us
              </button>
            </li>
            <li>
              <button data-testid="footer-reviews-link" onClick={() => scrollToSection("#reviews")} className="text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300">
                Reviews
              </button>
            </li>
            <li>
              <button data-testid="footer-quote-link" onClick={() => scrollToSection("#contact")} className="text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300">
                Get a Free Quote
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Contact</h3>
          <ul className="mt-5 flex flex-col gap-4">
            <li>
              <a data-testid="footer-phone-link" href="tel:07776714973" className="flex items-center gap-3 text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300">
                <Phone className="h-4 w-4 text-teal-400" /> 07776 714 973
              </a>
            </li>
            <li>
              <a data-testid="footer-email-link" href="mailto:hyekconnect@gmail.com" className="flex items-center gap-3 text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300">
                <Mail className="h-4 w-4 text-teal-400" /> hyekconnect@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
        <p className="text-xs text-slate-500">© 2026 Hyek Cleaning Services Ltd. All rights reserved.</p>
        <p className="text-xs text-slate-500">Fully insured · Eco-friendly · 100% satisfaction promise</p>
      </div>
    </div>
  </footer>
);
